import { AccountPermission } from 'modules/permissions/constants';
import { useAppSelector } from 'store/useAppSelector';

import { selectAccountPermissions } from '../store/selectors';

export interface IUseCheckAccountPermissionProps {
  permission: AccountPermission | undefined;
}

export const useCheckAccountPermission = ({
  permission,
}: IUseCheckAccountPermissionProps) => {
  const permissions = useAppSelector(selectAccountPermissions);

  return typeof permission === 'undefined' || permissions.includes(permission);
};
